<template>
  <div class="w-full mt-[10px] text-[16px]">
    <div class="mt-[30px] ml-5 font-bold text-[#fff]">{{ $t('Saque.EnterMessage.WithdrawalAmount') }}</div>
    <div class="px-[18px]">
      <div class="flex justify-between items-center mt-[25px] ml-[10px]">
        <div class="flex items-center gap-[13px]">
          <Image class="w-[24px] h-[24px]" :src="rIcon" alt="" />
          <span class="ml-[-5px] text-white/75">{{ $t('Deposit.valor') }}</span>
          <span class="w-[220px]">{{ formatNumber(sharedData.amount) }}</span>
        </div>
      </div>
      <div class="w-full h-[1px] bg-white/15 mt-[13px]"></div>
      <div class="flex flex-col mt-[25px] gap-[12px]">
        <span class="text-[#fff]/45 text-[15px]"> {{ $t('Saque.EnterMessage.TaxIDType') }} </span>
        <div
          :class="saqueType.length > 3 ? 'flex overflow-x-auto gap-3' : 'flex gap-3'"
          style="overflow-x: auto; white-space: nowrap"
        >
          <button
            v-for="item in saqueType"
            :key="item.type"
            @click="
              choose = item;
              id = '';
            "
            :class="[
              'w-[72px] h-[36px] rounded-lg text-[#fff] border-none',
              choose.type === item.type
                ? 'bg-[#2C7952]'
                : 'bg-[#2C7952]/20 text-[#fff]/85',
            ]"
            style="flex-shrink: 0"
          >
            {{ item.type }}
          </button>
        </div>
      </div>

      <div class="flex flex-col mt-[15px]">
        <div v-if="choose.value">
          <span class="text-[#fff]/45 text-[15px] block my-2">
            {{ choose.type }} {{ $t('Saque.EnterMessage.ID') }}
          </span>

          <div
            class="h-[44px] bg-[#2C7952]/70 flex items-center gap-[10px] px-[18px] rounded-[8px]"
          >
            <Image class="size-[24px]" :src="bankCard" alt="" />
            <span class="text-[15px]">{{ choose.value }}</span>
          </div>
        </div>
        <div v-else>
          <IconFormInput
            :label="choose.type + ' ID'"
            :placeholder="choose.placeholder"
            v-model="id"
            :icon="choose.type == 'Email' ? mail : bankCard"
            :errorMessage="id.length !== choose.rules && idFocus ? choose.tips : ''"
            @input="
              (e) => {
                idFocus = true;
                id = e.target.value;
                if (choose.type === 'Email') {
                  idFocus = !isValidEmail(e.target.value);
                }
                if (e.target.value.length === choose.rules) {
                  idFocus = false;
                }
              }
            "
          />
        </div>
      </div>

      <div class="flex flex-col mt-[12px] gap-[8px]">
        <div v-if="sharedData?.status == 'AUTHORIZED' && sharedData?.accountName">
          <span class="text-[#fff]/45 text-[15px] my-2 block">
            {{ $t('Saque.EnterMessage.BeneficiaryName') }} 
          </span>
          <div
            class="h-[45px] bg-[#2C7952]/70 flex items-center gap-[10px] px-[18px] rounded-[8px]"
          >
            <Image class="size-[24px]" :src="user" alt="" />
            <span class="text-[15px]">{{ sharedData?.accountName }}</span>
          </div>
        </div>
        <div v-else>
          <IconFormInput
            :label="$t('Saque.EnterMessage.BeneficiaryName')"
            :placeholder="commonType[0].placeholder"
            v-model="name"
            :icon="user"
            :errorMessage="''"
            @input="(e) => {}"
          />
        </div>
      </div>

      <div class="flex flex-col mt-[12px]">
        <div v-if="sharedData?.status == 'AUTHORIZED' && sharedData?.cpf">
          <span class="text-[#fff]/45 text-[15px] my-2 block"> {{ $t('meu.CPF') }} </span>
          <div
            class="h-[45px] bg-[#2C7952]/70 flex items-center gap-[10px] px-[18px] rounded-[8px]"
          >
            <Image class="size-[24px]" :src="bankCard2" alt="" />
            <span class="text-[15px]">{{ sharedData?.cpf }}</span>
          </div>
        </div>
        <div v-else>
          <IconFormInput
            :label="$t('meu.CPF')"
            :placeholder="commonType[1].placeholder"
            v-model="cpfValue"
            :icon="bankCard2"
            inputType="number"
            :errorMessage="
              cpfValue.length !== 11 && cpfValueFocus ? commonType[1].tips : ''
            "
            @input="
              (e) => {
                cpfValueFocus = true;
                cpfValue = e.target.value;
                if (e.target.value.length === 11) {
                  cpfValueFocus = false;
                }
              }
            "
          />
        </div>
      </div>

      <div class="text-[#fff]/50">
        <button
          @click="withdrawMoney()"
          :disabled="
            isDoingWithdrawMoney ||
            idFocus ||
            !(
              getParams().accountNo &&
              getParams().accountName &&
              getParams().cpf.length === 11
            )
          "
          :class="[
            'w-full h-[42px] mt-[60px] block mx-auto rounded-lg border-[1px] bg-[#151A1F] border-solid text-center border-[#fff]/50',
            !idFocus &&
            getParams().accountNo &&
            getParams().accountName &&
            getParams().cpf.length === 11
              ? 'bg-[#64F765]  text-[#151A1F]'
              : '',
          ]"
        >
        {{ $t('meu.Sake') }}
        </button>
      </div>

      <van-popup
        :close-on-click-overlay="false"
        v-model:show="showPassword"
        style="background: transparent; border: none"
      >
        <SendPassword
          v-if="showPassword"
          @confirm="handleConfirm"
          @close="showPassword = false"
        />
      </van-popup>

      <div class="text-center text-[13px] leading-[18px] mt-[35px] my-[70px]">
        {{ $t('Saque.EnterMessage.AccurateContactInformation') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatNumber } from "@/utils";
import rIcon from "@/themes/theme_a/views/Saque/images/rIcon.png";
import bankCard from "@/themes/theme_a/views/Saque/images/bank.png";
import bankCard2 from "@/themes/theme_a/views/Saque/images/bank.png";
import user from "@/themes/theme_a/views/Saque/images/user.png";
import mail from "@/themes/theme_a/views/Saque/images/email.png";
import IconFormInput from "@/themes/theme_a/components/IconFormInput/index.vue";
import SendPassword from "./SendPassword.vue";
import { withdrawOrder } from "@/api/saque";
const route = useRoute();
const searchParams = ref(route.query);
const supportTypes: any = searchParams.value.supportTypes;
const idFocus = ref(false);
const cpfValueFocus = ref(false);
const id = ref("");
const name = ref("");
const cpfValue = ref("");
const showPassword = ref(false);
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const choose = ref<any>({
  type: t('meu.CPF'),
  placeholder: t('Saque.EnterMessage.EnterYourCPFTips'),
  tips: t('Saque.EnterMessage.CPFRulesTips'),
  rules: 11,
  value: "",
});
const isDoingWithdrawMoney = ref(false);
const sharedData: any = inject("sharedData");
// 校验密码成功 ,生成取款订单
const handleConfirm = async (password: string) => {
  try {
    const res: any = await withdrawOrder(getParams(password));
    sharedData.value.orderNo = res.data.merchantOrderNo;
    if (res.code == 1) {
      sharedData.value.showAmount = 2;
    } else {
      sharedData.value.showAmount = 3;
    }
    showPassword.value = false;
  } catch (error) {
    console.log(error);
  }
};
//打开校验密码弹框
const withdrawMoney = async () => {
  showPassword.value = true;
};
// 获取参数
const getParams = (password?: string) => {
  const params = {
    payType: searchParams.value.type,
    accountType: "PIX_" + choose.value.type.toUpperCase(),
    accountNo: choose.value.value ? choose.value.value : id.value,
    accountName:
      sharedData.value.status && sharedData.value.accountName
        ? sharedData.value.accountName
        : name.value,
    cpf:
      sharedData.value.status && sharedData.value.cpf
        ? sharedData.value.cpf
        : cpfValue.value,
    amount: sharedData.value.amount,
    rolling: sharedData.value.limitAmount,
    withdrawalPassword: password,
  };
  return params;
};

const saqueType = computed(() => {
  const supportTypesArr = supportTypes?.split(",");
  const defaultarr = [
    {
      type: "CPF",
      placeholder: t('Saque.EnterMessage.EnterYourCPFTips'),
      tips: t('Saque.EnterMessage.CPFRulesTips'),
      rules: 11,
      value: sharedData.value.cpfId ? sharedData.value.cpfId : "",
    },
    {
      type: "Email",
      placeholder: t('Saque.EnterMessage.EnterYourEmailTips'),
      tips: t('Saque.EnterMessage.EmailRulesTips'),
      rules: 36,
      value: sharedData.value.accountEmail ? sharedData.value.accountEmail : "",
    },
    {
      type: "PHONE",
      placeholder: t('Saque.EnterMessage.EnterYourPhoneTips'),
      tips: t('Saque.EnterMessage.PhoneRulesTips'),
      rules: 11,
      value: sharedData.value.accountMobile ? sharedData.value.accountMobile : "",
    },
    {
      type: "CNPJ",
      placeholder: t('Saque.EnterMessage.EnterYourCNPJTips'),
      tips: t('Saque.EnterMessage.CNPJRulesTips'),
      rules: 14,
      value: sharedData.value.accountCnpj ? sharedData.value.accountCnpj : "",
    },
    {
      type: "EVP",
      placeholder: t('Saque.EnterMessage.EnterYourEVPTips'),
      tips: t('Saque.EnterMessage.EVPRulesTips'),
      rules: 36,
      value: sharedData.value.accountEvp ? sharedData.value.accountEvp : "",
    },
  ];

  const arr = defaultarr.filter((item) => {
    if (supportTypesArr?.includes(item.type.toLocaleLowerCase())) {
      return item;
    }
  });

  choose.value = arr[0];

  if (sharedData.value.accountCnpj && supportTypesArr?.includes("cnpj")) {
    choose.value = arr[supportTypesArr.findIndex((ele) => ele === "cnpj")];
  }
  if (sharedData.value.accountMobile && supportTypesArr?.includes("phone")) {
    choose.value = arr[supportTypesArr.findIndex((ele) => ele === "phone")];
  }
  if (sharedData.value.accountEmail && supportTypesArr?.includes("email")) {
    choose.value = arr[supportTypesArr.findIndex((ele) => ele === "email")];
  }
  if (sharedData.value.cpfId && supportTypesArr?.includes("cpf")) {
    choose.value = arr[supportTypesArr.findIndex((ele) => ele === "cpf")];
  }
  if (sharedData.value.accountEvp && supportTypesArr?.includes("evp")) {
    choose.value = arr[supportTypesArr.findIndex((ele) => ele === "evp")];
  }
  return arr;
});

const commonType = [
  {
    type: "Nome do beneficiário",
    placeholder: t('Saque.EnterMessage.PleaseProvide'),
    value: sharedData.value.accountName ? sharedData.value.accountName : "",
  },
  {
    type: "CPF",
    placeholder: t('Saque.EnterMessage.EnterYourCPF'),
    tips: t('Saque.EnterMessage.CPFRulesTips'),
    value: sharedData.value.cpf ? sharedData.value.cpf : "",
  },
];

// 校验邮箱
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
</script>

<style lang="scss" scoped></style>
